import { PetitionsStatePage } from './../pages/petitions-state/petitions-state';
import { AnnulmentsPage } from './../pages/annulments/annulments';
import { TasksPage } from './../pages/tasks/tasks';
import { Role } from './../models/roles';
import { GlobalVars } from './app.environment';
import { Component, ViewChild } from '@angular/core';
import { Platform, Nav, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { MailboxPage } from './../pages/mailbox/mailbox';
import { HomePage } from './../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { ConfigurationPage } from '../pages/configuration/configuration';
import { AreasPage } from '../pages/areas/areas';
//import { AppUpdate } from '@ionic-native/app-update';
//import { AppVersion } from '@ionic-native/app-version';
import { AuthProvider } from '../providers/auth/auth';
import { User } from '../models/user';
import { UsersPage } from '../pages/users/users';
import { PetitionAbsencePage } from '../pages/petition-absence/petition-absence';
import { WorkDaysPage } from '../pages/work-days/work-days';
import { PetitionExtraHoursPage } from '../pages/petition-extra-hours/petition-extra-hours';
import { PetitionHourCompensationPage } from '../pages/petition-hour-compensation/petition-hour-compensation';
import { ReportSelectionPage } from '../pages/report-selection/report-selection';
import { PetitionsHistoryPage } from '../pages/petitions-history/petitions-history';
import { ConfigurationProvider } from '../providers/configuration/configuration';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild('NAV') nav: Nav;
  
  pages: Array<{title: string, component: any, icon: string}>;
  rootPage:any = LoginPage;

  pagesConfigSubscription;

  // updateUrl = 'https://www.gestionvacaciones.com/repository/repoVersion.xml';
  

  constructor(
    private platform: Platform, 
    private statusBar: StatusBar, 
    private splashScreen: SplashScreen,
    public authProvider: AuthProvider,
    private globalVars: GlobalVars,
    public events: Events,
    // private appUpdate: AppUpdate,
    // private appVersion: AppVersion,

    private configurationProvider: ConfigurationProvider,
  ) {
    this.initializeApp();
  }

  /**
   * Mètode per anar a la pàgina indicada per paràmetre.
   * El cas d'anar a la pàgina login s'ha de fer primer 
   * un logout.
   * 
   * @param page Pàgina a la que es desitja anar.
   */
  goToPage(page: any){
    if(page.name == 'LoginPage') { 
      this.authProvider.signOut();
      this.globalVars.user = null;
    }
    
    else if(this.nav.getActive().component.name != page.name) this.nav.push(page);
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();

      this.verifyUpdates();
      this.goToMainPage();
    });
  }

  /**
   * Mètode per configurar el menú lateral en funció
   * del rol de l'usuari actual.
   */
  private configRolePages() {

    if (this.globalVars.user.role != Role.unauthorized) {
    
      this.pagesConfigSubscription = this.configurationProvider.getPagesConfig().subscribe(config => {
        
        if (this.globalVars.user.role == Role.normal) {
          this.pages = [
            { title: 'Inicio',                   component: HomePage,                     icon: 'home'},
            { title: 'Buzón',                    component: MailboxPage,                  icon: 'mail'},
            { title: 'Tareas',                   component: TasksPage,                    icon: 'checkmark'},
            { title: 'Solicitud de ausencias',   component: PetitionAbsencePage,          icon: 'help'},
            { title: 'Petición de horas extra',  component: PetitionExtraHoursPage,       icon: 'time'},
            { title: 'Compensación horas extra', component: PetitionHourCompensationPage, icon: 'clock'},
            { title: 'Anular peticiones',        component: AnnulmentsPage,               icon: 'undo'},
            { title: 'Informes',                 component: ReportSelectionPage,          icon: 'document'},
            { title: 'Configuración',            component: ConfigurationPage,            icon: 'settings'},
            { title: 'Desconectar',              component: LoginPage,                    icon: 'power'},
          ]

          if(config.stateEnabled) this.pages.splice(2, 0, { title: 'Estado de las peticiones', component: PetitionsStatePage, icon: 'shuffle'})
          else this.pages = this.pages.filter(page => page.title != 'Estado de las peticiones')
          
          if(config.historyEnabled) this.pages.splice(2, 0, { title: 'Historial', component: PetitionsHistoryPage, icon: 'archive'})
          else this.pages = this.pages.filter(page => page.title != 'Historial')
          
          console.log('normal user');
    
        } else if (this.globalVars.user.role == Role.admin) {
          this.pages = [
            { title: 'Inicio',                   component: HomePage,                     icon: 'home'},
            { title: 'Buzón',                    component: MailboxPage,                  icon: 'mail'},
            { title: 'Tareas',                   component: TasksPage,                    icon: 'checkmark'},
            { title: 'Solicitud de ausencias',   component: PetitionAbsencePage,          icon: 'help'},
            { title: 'Petición de horas extra',  component: PetitionExtraHoursPage,       icon: 'time'},
            { title: 'Compensación horas extra', component: PetitionHourCompensationPage, icon: 'clock'},
            { title: 'Anular peticiones',        component: AnnulmentsPage,               icon: 'undo'},
            { title: 'Usuarios',                 component: UsersPage,                    icon: 'person'},
            { title: 'Áreas',                    component: AreasPage,                    icon: 'flag'},
            { title: 'Días festivos',            component: WorkDaysPage,                 icon: 'calendar'},
            { title: 'Informes',                 component: ReportSelectionPage,          icon: 'document'},
            { title: 'Configuración',            component: ConfigurationPage,            icon: 'settings'},
            { title: 'Desconectar',              component: LoginPage,                    icon: 'power'},
          ]

          if(config.stateEnabled) this.pages.splice(2, 0, { title: 'Estado de las peticiones', component: PetitionsStatePage, icon: 'shuffle'})
          else this.pages = this.pages.filter(page => page.title != 'Estado de las peticiones')
          
          if(config.historyEnabled) this.pages.splice(2, 0, { title: 'Historial', component: PetitionsHistoryPage, icon: 'archive'})
          else this.pages = this.pages.filter(page => page.title != 'Historial')
          
          console.log('admin user');
        }
      })
    }

    else {
      this.pages = []
      if(this.pagesConfigSubscription && !this.pagesConfigSubscription.closed) this.pagesConfigSubscription.unsubscribe()

      console.log('unauthorized user');
    }
  }

  private goToMainPage() {
    this.authProvider.getProfile().subscribe((user: User) => { 
      this.globalVars.user = user;
   
      console.log(this.globalVars.user);

      if(this.globalVars.user.role != Role.unauthorized) this.rootPage = HomePage;
      else this.rootPage = LoginPage;

      this.configRolePages();
    });
  }

  private verifyUpdates(){
    /*
    console.log(this.appVersion.getVersionCode());
    console.log(this.appVersion.getVersionNumber());
    this.appUpdate.checkAppUpdate(this.updateUrl);
    */
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts